import CouponsEntity from '@/entities/api/coupons/coupons'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface CouponsSlice {
	coupons: CouponsEntity[]
}

const initialState: CouponsSlice = {
	coupons: [],
}

const couponsSlice = createSlice({
	name: 'coupons',
	initialState,
	reducers: {
		setCouponsFn: (state, action: PayloadAction<CouponsEntity[]>) => {
			state.coupons = action.payload
		},
		addCouponFn: (state, action: PayloadAction<CouponsEntity>) => {
			state.coupons.push(action.payload)
		},
		updateCouponFn: (state, action: PayloadAction<CouponsEntity>) => {
			const index = state.coupons.findIndex(
				(coupon) => coupon._id === action.payload._id
			)
			if (index !== -1) {
				state.coupons[index] = action.payload
			}
		},
		deleteCouponFn: (state, action: PayloadAction<string>) => {
			state.coupons = state.coupons.filter(
				(coupon) => coupon._id !== action.payload
			)
		},
	},
})

export const {
	setCouponsFn,
	addCouponFn,
	updateCouponFn,
	deleteCouponFn,
} = couponsSlice.actions

export default couponsSlice.reducer
